import { asError, getLogger } from '@trimble/logging';

import { PERSISTENCE_KEY } from '../constants/make-persisted-constants';

type FxActiveWorkspaceByRepositoryKey = Record<string, string>;

function readStorageMap(): FxActiveWorkspaceByRepositoryKey {
  try {
    const raw = localStorage.getItem(PERSISTENCE_KEY.FxActiveWorkspace);
    if (!raw) {
      return {};
    }

    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed !== 'object' ||
      parsed === null ||
      Array.isArray(parsed)
    ) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(parsed).filter(
        (entry): entry is [string, string] => typeof entry[1] === 'string'
      )
    );
  } catch (error) {
    getLogger().error(
      'Failed to read persisted FX active workspace',
      undefined,
      asError(error)
    );
    return {};
  }
}

function writeStorageMap(map: FxActiveWorkspaceByRepositoryKey): void {
  try {
    if (Object.keys(map).length === 0) {
      localStorage.removeItem(PERSISTENCE_KEY.FxActiveWorkspace);
      return;
    }

    localStorage.setItem(
      PERSISTENCE_KEY.FxActiveWorkspace,
      JSON.stringify(map)
    );
  } catch (error) {
    getLogger().error(
      'Failed to write persisted FX active workspace',
      undefined,
      asError(error)
    );
  }
}

export function readPersistedActiveWorkspace(
  repositoryKey: string
): string | undefined {
  return readStorageMap()[repositoryKey];
}

export function writePersistedActiveWorkspace(
  repositoryKey: string,
  workspaceId: string | undefined
): void {
  const map = readStorageMap();

  if (workspaceId === undefined) {
    delete map[repositoryKey];
  } else {
    map[repositoryKey] = workspaceId;
  }

  writeStorageMap(map);
}
